import { BaseControl } from "../base-control";
// out: stdModel(epoch)

class DateControlCtrl extends BaseControl {
  dtModel;
  datePickerOptions = {
    showClose: true,
    showClear: true,
    format: false,
    useCurrent: false
  }

  constructor(BaseControlService, $scope, $element) {
    'ngInject';
    super(BaseControlService, $scope);
    Object.assign(this, { $element });
  }

  async initializeControlData() {
    await super.initializeControlData();
    this.datePickerOptions.format = this.token.control.fmtDateDisplay;
    this.dtModel = this.stdModel();
    this.isPrint && this.$scope.$on('datetimepickerUpdated', _  => this.setPrintText() );
  }

  modelChanged(newVal, oldVal) {
    super.modelChanged(newVal, oldVal);
    // Note: handle multiple instances of field
    this.dtModel = this.stdModel();
  }

  setPrintText() {
    const formattedValue = this.$element.find(`#${this.token.id}-output-value`).val();
    this.$element.find(`#${this.token.id}-output-text`).text(formattedValue);
  }
  
  // Note: on-change (dtChange) is triggered by datetimepicker directive
  dtChange(value) {
    if (!value) {
      this.stdModel(value);
      return;
    }
    // Shift time to deal with UTC problems??
    const shifted = value.clone().add(value.utcOffset(), 'minutes');
    // Example for London (substracts one day):
    // Original value (UTC): 2025-08-30T23:00:00Z 1756594800000
    // Shifted value (UTC):  2025-08-31T00:00:00Z 1756598400000
    const epoch = parseInt(shifted.valueOf().toString());
    this.stdModel(epoch);
  }

}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/date-control/date-control.component.html",
  controller: DateControlCtrl
};